import VolunteerServices from '../../services/application/Volunteer';

export const state = {
    volunteers: [],
    volunteer: {},
}

export const mutations = {
    setVolunteer(state, volunteer) {
        state.volunteer = volunteer
    },
    setVolunteers(state, volunteers) {
        state.volunteers = volunteers
    }
}

export const getters = {
    getVolunteer(state) {
        return state.volunteer;
    },
    getVolunteers(state) {
        return state.volunteers;
    },
}

export const actions = {
    get({commit}, id){
        return VolunteerServices.get(id)
        .then((response)=>{
            commit('setVolunteer', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return VolunteerServices.getAll(data)
        .then((response)=>{
            commit('setVolunteers', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return VolunteerServices.delete(id)
        .then((response)=>{
            commit('setVolunteers', state.volunteers.filter((x)=>x.id != id))
            return response
        })
    },
}